/**
 * "Ding" curto de dois tons sintetizado com Web Audio (sem arquivo de áudio).
 * Navegadores só liberam áudio após interação do usuário: `destravarAudioNotificacao`
 * deve rodar num clique/tecla; antes disso o som é ignorado sem erro.
 */
let contexto: AudioContext | null = null;

function obterContexto(): AudioContext | null {
  if (typeof window === "undefined" || typeof window.AudioContext === "undefined") return null;
  contexto ??= new window.AudioContext();
  return contexto;
}

function destravarAudioNotificacao(): void {
  const audio = obterContexto();
  if (audio?.state === "suspended") {
    void audio.resume().catch(() => undefined);
  }
}

function tocarNota(audio: AudioContext, frequencia: number, inicio: number, duracao: number) {
  const oscilador = audio.createOscillator();
  const volume = audio.createGain();

  oscilador.type = "sine";
  oscilador.frequency.setValueAtTime(frequencia, inicio);
  // ataque rápido e decaimento suave para não soar como bipe seco
  volume.gain.setValueAtTime(0.0001, inicio);
  volume.gain.exponentialRampToValueAtTime(0.18, inicio + 0.015);
  volume.gain.exponentialRampToValueAtTime(0.0001, inicio + duracao);

  oscilador.connect(volume).connect(audio.destination);
  oscilador.start(inicio);
  oscilador.stop(inicio + duracao + 0.02);
}

function tocarSomNotificacao(): void {
  const audio = obterContexto();
  if (!audio || audio.state !== "running") return;

  const agora = audio.currentTime;
  tocarNota(audio, 880, agora, 0.25);
  tocarNota(audio, 1318.5, agora + 0.12, 0.35);
}

/**
 * EXPORTS
 */
export { destravarAudioNotificacao, tocarSomNotificacao };
